import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import {
  type ProductCategories,
  ProductCategoriesSchema,
} from './product-category'

export type ProductGradesApiProps = {
  technicalName?: string
  categories: ProductCategories
  title?: string
  subtitle?: string
  button?: CmsButtonApiProps
}

export const ProductGradesApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  categories: ProductCategoriesSchema,
  button: CmsButtonApiPropsSchema.optional(),
})

/* Schemas validation */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type TestProductGrades = ExpectTrue<
  Equal<ProductGradesApiProps, z.infer<typeof ProductGradesApiPropsSchema>>
>
